import React, { useState } from "react";
import Slide from "../HomepageSlider/Slide";

const Promotions = ({ promotions, filter, totalPages }) => {
  const [promos, setPromos] = useState(promotions);
  const [page, setPage] = useState(1);

  const url = '/promotions';

  const axios = require('axios');
  axios.defaults.headers.common['Accept'] = 'application/json';

  const handleSubmit = e => {
    e.preventDefault();

    axios.get(url, {
      params: { page: page + 1, filter: filter }
    }, {headers: {'Content-Type': 'text/javascript'}})
    .then(function (response) {
      setPromos([...promos, ...response.data]);
      setPage(page + 1);
    })
    .catch(function (error) {
      console.log(error);
    });
  };

  function Cards(props) {
    const index = props.index;
    const element = props.element;

    if (index != 0) {
      return (
        <div className="promos-page__news-card-small animation-waypoint animation-trigger">
          <Slide
            title={element.title}
            duration={element.duration}
            link={element.link}
            oldPrice={element.oldPrice}
            newPrice={element.newPrice}
            image={element.image}
            className={element.className}
            description={element.description}
          />
        </div>
      )
    }
    return (null);
  }

  return (
    <div>
      <div className="promos-container__cards">
        {promos.map((element, elIndex) => (
          <Cards index={elIndex} element={element} key={elIndex} />
        ))}
      </div>
      { page < totalPages &&
        (
            <div className="promos-container__more animation-waypoint animation-trigger">
              <a className="button button_large" onClick={handleSubmit} rel="next">Загрузить еще</a>
            </div>
        )
      }

    </div>
  )
}

export default Promotions;
